import styled, { css } from 'styled-components';
import { cssColorValue } from "../../styles";
var iconSizes = {
  16: '0.8pt',
  24: '1pt',
  32: '1.2pt',
  48: '1.4pt',
  64: '1.6pt'
};
export default styled.svg.withConfig({
  displayName: "Svg",
  componentId: "ytk21e-0"
})(["", ";*{vector-effect:non-scaling-stroke;}*[fill='#181818']{", "}*[stroke='#181818']{", "}"], function (props) {
  return css(["stroke-width:", ";"], iconSizes[props.iconSize]);
}, function (props) {
  return props.iconColor ? css(["fill:", ";"], cssColorValue(props.iconColor)) : css(["fill:currentColor;"]);
}, function (props) {
  return props.iconColor ? css(["stroke:", ";"], cssColorValue(props.iconColor)) : css(["stroke:currentColor;"]);
});